// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35tnz","buttons":"styles_buttons__2kmXs"};